import requestReducer from '../requestReducer';
import UsePrepayment from '../../models/UsePrepayment';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'


export interface UsePrepaymentDetailState extends PaginatedApiState {
  usePrepaymentLines?: UsePrepayment[]
}

const UsePrepaymentDetail = (state: UsePrepaymentDetailState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<UsePrepaymentDetailState>('USE_PREPAYMENT_DETAIL')(state, action)
  }
}

export default UsePrepaymentDetail